
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import AddPost from "./Add/index";
import MagazineList from "./List/Index";

import EditPost from "./Edit/index";
const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "230px",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnActive: {
        padding: theme.spacing(1.2),
        borderRadius: "10px",
        maxWidth: "230px",
        backgroundColor: "#950000",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#950000",
            boxShadow: "none",
        },
        color: "#fff",
        width: "100%",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
        width: '100%'
    },
    grayerBox: {
        backgroundColor: "#DFDFDF",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    mr: {
        marginLeft: "5px",
    },
}));
const allTabs = [
    {
        name: "لیست مقالات",
        value: "articleList",
        //  component: <ProductLists />,
    },
    {
        name: "افزودن مقاله جدید",
        value: "newArticle",
        component: <AddPost />,
    },
];
const ManageProducts = () => {
    const classes = useStyles();
    const [tabs, setTabs] = useState("articleList");
    const [edit, setEdit] = useState(false);
    const [articleId, setArticleId] = useState(null);

    const vlidating = (inner, outter, defaultValue) => {
        if (tabs === inner) {
            return outter;
        } else {
            return defaultValue;
        }
    };

    const activer = (tab) => {
        setTabs(tab);
    };
    const handleEditArticle = (status, id) => {
        setEdit(status);
        setArticleId(id);
    };
    return (
        <Box borderRadius={10} mt={2} mr={2} className={classes.grayBox}>
            {!edit ? (
                <>
                    <Box className={classes.grayerBox} borderRadius={10}>
                        {allTabs.map((tab) => (
                            <Button
                                className={vlidating(tab.value, classes.btnActive, classes.btn)}
                                variant={vlidating(tab.value, "contained")}
                                onClick={() => activer(tab.value)}
                            >
                                {tab.name}
                            </Button>
                        ))}
                    </Box>
                    {allTabs.map((tab) => tabs === tab.value && tab.component)}
                    {tabs === allTabs[0].value && (<MagazineList onEdit={handleEditArticle} />)}
                </>
            ) : (
                <EditPost id={articleId} onBack={handleEditArticle} />

            )}
        </Box>
    );
};

export default ManageProducts;
